import { Box } from "@mui/material";
import { FormikProps } from "formik";

import { AssetDocumentArea, AssetDocumentZone, PendingDocumentMove } from "../../../api/ClientFileApi";
import { ClientFileQueryKey } from "../../../query/clientFileQueryKeys";
import { useAssetInventoryDocuments } from "../../hooks/useAssetInventoryDocuments";
import {
  AssetDocumentsFormValues,
  AssetDocumentsSection,
  PendingFilesField,
} from "../asset-documents-section/AssetDocumentsSection";
import { FieldSpacer } from "../field-spacer/FieldSpacer";

export interface InventoryUploadAreaConfig<TField extends string> {
  area: AssetDocumentArea;
  zone: AssetDocumentZone;
  queryKey: ClientFileQueryKey;
  fieldName: TField;
}

interface Props<T extends AssetDocumentsFormValues> {
  clientId: string;
  formik: FormikProps<T>;
  config: InventoryUploadAreaConfig<PendingFilesField<T>>;
  label: string;
  onAddMove: (move: PendingDocumentMove) => void;
  onCancelMove: (documentId: string) => void;
}

export function InventoryUploadArea<T extends AssetDocumentsFormValues>({
  clientId,
  formik,
  config,
  label,
  onAddMove,
  onCancelMove,
}: Props<T>) {
  const { area, zone, queryKey, fieldName } = config;
  const { documents, markRead, deleteDocument, isBusy } = useAssetInventoryDocuments(clientId, {
    queryKey,
    getDocuments: (api, params) => api.getAssetInventoryAssetDocuments({ ...params, area }),
    getDeleteDocument: (api) => (params) => api.deleteAssetInventoryAssetDocument({ ...params, area }),
  });

  return (
    <Box>
      <AssetDocumentsSection
        clientId={clientId}
        formik={formik}
        fieldName={fieldName}
        zone={zone}
        title={label}
        uploadHint={label}
        embedded
        documents={documents}
        onMarkRead={markRead}
        onDelete={deleteDocument}
        isBusy={isBusy}
        onAddMove={onAddMove}
        onCancelMove={onCancelMove}
      />
      <FieldSpacer />
    </Box>
  );
}
